module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_6_4.52077a92.png";